<template>
    <div ref="doc_parent_div" v-if="this.isSurportHtml" :style="{ height: `${isUnLogin ? (this.screenHeight - 55) : (this.screenHeight - 200 -38)}px`, 'overflow':'auto' }" v-loading="loading">
        <el-tag type="danger" size="mini" effect="light" style="position: absolute" v-if="changed">尚未保存</el-tag>
        <iframe ref="doc" :src="src" :srcdoc="srcdoc" id="resultpage" allow="microphone;camera;canvas" class="docframe width-p100" seamless style="height:99%"></iframe>
    </div>
    <el-scrollbar v-else v-loading="loading">
        <div style="padding: 10px 50px; opacity: 0.2; color: red; position: absolute; border: red; width: 50px; height: 50px; font-size: 50px; z-index: 1000" :class="{ display: isHide }">
            <div>已归档</div>
        </div>
        <div class="docframe" :style="{ padding: '10px', 'min-height': `${this.screenHeight - 120}px` }">
            <pdf v-for="i in numPages" :key="i" :src="src2" :page="i"></pdf>
        </div>
    </el-scrollbar>
</template>

<script>
import axios from 'axios'
import myaxios from '@/myaxios.js'
import { mapGetters } from 'vuex'
import Qs from 'qs'
import pdf from '@/common/vue-pdf-4.1.0'
function generateUUID() {
    var d = new Date().getTime()
    var uuid = `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c == `x` ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
}

// 用于预览单份所见所得文书
export default {
    name: `DocFrame`,
    components: { pdf },
    props: {
        docno: { type: Number | String, required: true },
        guid: { type: String },
        printer_name2: { type: String },
        docbizid: { type: String },
        fromDt: ``,
        toDt: ``,
        deptno: { type: String, default: `acis2020` },
        permission: `00000000000`,
        docname: {
            type: String,
            default: () => {
                return generateUUID()
            }
        },
        surgeryId: ``,
        isSurportHtml: { type: Boolean, default: true },
        extraParams: { type: Object, default: () => {} },
        templateid: { type: String | Number },
        resetHeight: { type: Boolean, default: true },
        isHide: { type: Boolean, default: true },
        isUnLogin: { type: Boolean, default: false },
        caStatus: { type: Number, default: 0 },
        isSignMultipleTimes: { type: Boolean, default: false }
    },
    data() {
        // 监听页面回传消息
        // 由于【保存】 【归档】 【取消归档】等按钮是触发子页面相应功能完成的，需要监听子页面回传的消息作后续操作
        window.addEventListener(
            `message`,
            event => {
                if (event.data.order == `resize`) {
                    // console.log(event.data)
                    // let iframe = this.$refs.doc
                    // if (iframe && this.resetHeight) {
                    //     iframe.style.height = `${event.data.height + 20}px`
                    // }
                } else if (event.data.order == `aftersave`) {
                    if (event.data.type == 1) {
                        // 数据被缓存到浏览器，在界面提示未提交缓存数量
                        this.changed = false
                        this.$emit(`saved`, event.data)
                    }
                } else if (event.data.order == `changed`) {
                    this.changed = event.data.changed
                    this.$emit(`changed`, this.changed)
                } else if (event.data.order == `afterdisarchive`) {
                    this.$emit(`afterdisarchive`, event.data)
                } else if (event.data.order == `afterarchive`) {
                    this.$emit(`afterarchive`, event.data)
                } else if (event.data.order == `checkprint`) {
                    console.log(`checkprint`, event.data)
                    if (event.data.status !== false) {
                        this.$emit(`aftercheckprint`, event.data)
                    }
                }
            },
            false
        )
        return {
            title: `doc-frame`,
            docid: { type: String },
            host: this.$root.DOCSERVICE_BASE,
            src: ``,
            src2: ``,
            srcdoc: undefined,
            user: undefined,
            changed: false,
            loading: false,
            numPages: 0,
            src_docno: null,
            src_docbizid: null,
            src_guid: null
        }
    },
    created() {

    },
    mounted() {
    },
    computed: {
        ...mapGetters([`currentUser`, `screenHeight`, `localip/ipAddress`])
    },
    methods: {
        loadDocument(srcdocno, srcdocbizid, srcguid) {
            this.src_docno = srcdocno
            this.src_docbizid = srcdocbizid
            this.src_guid = srcguid

            if (!this.docno) {
                this.$message.warning(`请配置相关文书`)
                return
            }
            this.loading = true
            if (this.isSurportHtml) {
                this.loadLateastTemplates()
                    .then(data => {
                        this.docid = data.SysID
                        this.loadInstance(data.SysID)
                    })
                    .catch(e => {
                        this.loading = false
                    })
            } else {
                window.localStorage.setItem(`savefalg`, `True`)
                this.docid = this.docno
                this.$store
                    .dispatch(`LOAD_PDF_DATA`, {
                        host: this.host,
                        params: Object.assign(
                            {
                                docid: this.docno,
                                from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                                id1: this.surgeryId,
                                id3: 1
                            },
                            this.extraParams
                        )
                    })
                    .then(data => {
                        this.src2 = pdf.createLoadingTask(`data:application/pdf;base64,${data}`)
                        this.src2.then(content => {
                            this.numPages = content.numPages
                            this.loading = false
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        this.loading = false
                    })
            }
        },
        verifydoc() {
            let req = myaxios.get(`/api/AcisSystem/Menu/Get`) // 获取所有菜单项目
            return new Promise(resolve => {
                req.then(data => {
                    var p = `verifydata|docbizid|` + this.docbizid
                    this.$refs.doc.contentWindow.postMessage({ order: p }, `*`)
                    resolve()
                }).catch(e => {
                    console.log(e)
                    resolve()
                })
            })
        },
        checkprint() {
            if (this.docbizid > 0) {
                this.$refs.doc.contentWindow.postMessage({ order: `print` }, `*`)
            } else {
                this.$emit(`aftercheckprint`)
            }
        },
        print() {
            if (this.docbizid > 0) {
                this.verifydoc()
            }
            // 查询归档信息
            let req1 = myaxios.get_doc(`wth/QueryInstanceById?docbizid=${this.docbizid}`)
            req1.then(doc => {
                if (!doc.HtmlURl) {
                    console.log(`默认打印机begin`)
                    console.log(this.printer_name2)
                    console.log(`默认打印机end`)
                    if (this.printer_name2 != null && this.printer_name2 != ``) {
                        this.$store.dispatch(`PRINT_PDF_MehealthAgreement`, {
                            host: this.$root.DOCSERVICE_BASE,
                            params: Object.assign(
                                {
                                    docid: this.docid || this.docno,
                                    id1: this.surgeryId,
                                    docbizid: this.docbizid,
                                    from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                                    to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                                    default_printer_name: this.printer_name2,
                                    username: this.currentUser.dic_worker_name
                                },
                                this.extraParams
                            )
                        })
                    } else {
                        this.$store.dispatch(`PRINT_PDF`, {
                            host: this.$root.DOCSERVICE_BASE,
                            params: Object.assign(
                                {
                                    docid: this.docid || this.docno,
                                    id1: this.surgeryId,
                                    docbizid: this.docbizid,
                                    from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                                    to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                                    username: this.currentUser.dic_worker_name
                                },
                                this.extraParams
                            )
                        })
                    }

                    return Promise.resolve({})
                }
            })
        },
        wztPdfUploadInstance() {
            let req1 = myaxios.get_doc(`wth/QueryInstanceById?docbizid=${this.docbizid}`)
            req1.then(doc => {
                if (doc && doc.Content && (!doc.Content.CaStatus || doc.Content.CaStatus <= 0 || this.isSignMultipleTimes)) {
                    this.$store.dispatch(`WZT_PDF_SendSign`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.docid || this.docno,
                                id1: this.surgeryId,
                                docbizid: this.docbizid,
                                from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                                operator: this.currentUser.dic_worker_name
                            },
                            this.extraParams
                        )
                    }).then(data => {
                        this.loadDocument()
                        // this.$message.success(`发送签名成功！`)
                    })
                        .catch(e => {
                            this.$message.error(e)
                            console.log(e)
                        })
                } else {
                    console.log(doc)
                }
            })
        },
        wztCaRevokePdf() {
            let req1 = myaxios.get_doc(`wth/QueryInstanceById?docbizid=${this.docbizid}`)
            req1.then(doc => {
                if (doc && doc.Content && doc.Content.CaStatus && doc.Content.CaStatus > 0) {
                    this.$store.dispatch(`WZT_CaRevokePdf`, {
                        host: this.$root.DOCSERVICE_BASE,
                        params: Object.assign(
                            {
                                docid: this.docid || this.docno,
                                id1: this.surgeryId,
                                docbizid: this.docbizid,
                                from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                                to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                                operator: this.currentUser.dic_worker_name
                            },
                            this.extraParams
                        )
                    }).then(data => {
                        this.loadDocument()
                        // this.$message.success(`取消签名成功！`)
                    })
                        .catch(e => {
                            this.$message.error(e)
                            console.log(e)
                        })
                } else {
                    console.log(doc)
                }
            })
        },
        save() {
            if (this.docbizid > 0) {
                // 查询归档信息
                let req1 = myaxios.get_doc(`wth/QueryLastUpdateData?docbizid=${this.docbizid}`)
                req1.then(item => {
                    let wth = item.Content[0]
                    if (wth.creator && this.currentUser.dic_worker_name != wth.creator) {
                        this.$confirm(wth.creator + `于` + wth.lastupdatedt + `最后一次编辑，是否确认保存，保存后将覆盖?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            if (this.docno) {
                                if (this.src_docbizid) {
                                    var p0 = `changedoc|docid|` + this.docid
                                    var p1 = `changedoc|docbizid|` + this.src_docbizid
                                    var p2 = `changedoc|docguid|` + this.src_guid
                                    this.$refs.doc.contentWindow.postMessage({ order: p0 }, `*`)
                                    this.$refs.doc.contentWindow.postMessage({ order: p1 }, `*`)
                                    this.$refs.doc.contentWindow.postMessage({ order: p2 }, `*`)
                                }
                                this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                                window.localStorage.setItem(`savefalg`, `True`)
                            } else {
                                this.$emit(`saved`, event.data)
                            }
                        })
                    } else {
                        if (this.docno) {
                            if (this.src_docbizid) {
                                var p0 = `changedoc|docid|` + this.docid
                                var p1 = `changedoc|docbizid|` + this.src_docbizid
                                var p2 = `changedoc|docguid|` + this.src_guid
                                this.$refs.doc.contentWindow.postMessage({ order: p0 }, `*`)
                                this.$refs.doc.contentWindow.postMessage({ order: p1 }, `*`)
                                this.$refs.doc.contentWindow.postMessage({ order: p2 }, `*`)
                            }
                            this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                            window.localStorage.setItem(`savefalg`, `True`)
                        } else {
                            this.$emit(`saved`, event.data)
                        }
                    }
                })
            } else {
                if (this.docno) {
                    if (this.src_docbizid) {
                        var p0 = `changedoc|docid|` + this.docid
                        var p1 = `changedoc|docbizid|` + this.src_docbizid
                        var p2 = `changedoc|docguid|` + this.src_guid
                        this.$refs.doc.contentWindow.postMessage({ order: p0 }, `*`)
                        this.$refs.doc.contentWindow.postMessage({ order: p1 }, `*`)
                        this.$refs.doc.contentWindow.postMessage({ order: p2 }, `*`)
                    }
                    this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                    window.localStorage.setItem(`savefalg`, `True`)
                } else {
                    this.$emit(`saved`, event.data)
                }
            }
        },
        saveAndprint() {
            this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
            window.localStorage.setItem(`savefalg`, `True`)
        },
        dataUpdate(type) {
            if (this.docbizid > 0) {
                // 查询归档信息?docbizid=参数   type=1  表示页面的刷新调用   type=2 表示 打印的时候调用
                let req1 = myaxios.get_doc(`wth/BehandDoInstances`, { docbizid: this.docbizid, type: type })
                req1.then()
            } else {
                if (this.docno) {
                    if (this.src_docbizid) {
                        var p0 = `changedoc|docid|` + this.docid
                        var p1 = `changedoc|docbizid|` + this.src_docbizid
                        var p2 = `changedoc|docguid|` + this.src_guid
                        this.$refs.doc.contentWindow.postMessage({ order: p0 }, `*`)
                        this.$refs.doc.contentWindow.postMessage({ order: p1 }, `*`)
                        this.$refs.doc.contentWindow.postMessage({ order: p2 }, `*`)
                    }
                    this.$refs.doc.contentWindow.postMessage({ order: `save` }, `*`)
                } else {
                    this.$emit(`saved`, event.data)
                }
            }
        },
        archive() {
            this.$confirm(`确认归档?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.$refs.doc.contentWindow.postMessage({ order: `archive` }, `*`)
                this.verifydoc()
            })
        },
        disArchive() {
            this.$confirm(`确认取消归档?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                this.$refs.doc.contentWindow.postMessage({ order: `disarchive` }, `*`)
            })
        },
        saveAsTemplate(type) {
            let that = this
            this.$prompt(`请输入名称`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                closeOnClickModal: false
            }).then(({ value }) => {
                this.$refs.doc.contentWindow.postMessage({ order: `saveastemplate`, type: type, docname: value }, `*`)
                setTimeout(function() {
                    that.$emit(`aftersaveastemplate`)
                }, 2000)
            })
        },
        loadMeta(doc, attrname, content) {
            let node = doc.getElementsByName(attrname)
            if (node.length == 0) {
                node = doc.createElement(`meta`)
                node.setAttribute(`name`, attrname)
                node.setAttribute(`content`, content)
                doc.head.appendChild(node)
            }
        },
        delete() {},
        loadUser() {
            let token = sessionStorage.getItem(`token`)
            if (!token || token === `undefined` || token === `null`) {
                return {
                    dic_worker_name: `gust`,
                    dic_worker_id: `gust`
                }
            } else if (!this.currentUser) {
                return this.myaxios.get(`/api/AcisSystem/SysUser/GetCurrentUser`)
            } else {
                return this.currentUser
            }
        },
        loadLateastTemplates() {
            return new Promise((resolve, reject) => {
                let req1 = this.loadUser()
                let req2 = axios.post(`${this.host}/WthOffline/LateastTemplates`, Qs.stringify({ docids: [this.docno] }, { indices: false }), {
                    headers: { 'content-type': `application/x-www-form-urlencoded` }
                })
                this.myaxios
                    .all(req1, req2)
                    .then(([user, res]) => {
                        this.user = user
                        if (res.status == `success`) {
                            resolve(_.orderBy(res.data, `SysID`, `desc`)[0])
                        } else {
                            reject()
                        }
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        loadInstance(docid) {
            if (!this.user) return
            this.changed = false
            let docsingleton = window.localStorage.getItem(`docsingleton`)
            axios
                .get(`${this.host}/doc3.ashx/wth`, {
                    params: Object.assign(
                        {
                            vid: this.surgeryId,
                            from: this.$moment(this.fromDt).format(`YYYYMMDDHHmm`),
                            to: this.$moment(this.toDt).format(`YYYYMMDDHHmm`),
                            dept: this.deptno,
                            operator: this.user.dic_worker_name,
                            username: this.user.dic_worker_id,
                            catoken: sessionStorage.getItem(`caToken`),
                            templateid: this.templateid,
                            strategy: `UF`,
                            guid: this.guid || generateUUID(),
                            docid: docid,
                            docname: this.docname,
                            docbizid: this.templateid ? null : this.docbizid,
                            singleton: docsingleton
                        },
                        this.extraParams
                    )
                })
                .then(res => {
                    if (res.Status == `SUCCESS`) {
                        this.docid = res.DocId || docid
                        this.srcdoc = undefined
                        window.localStorage.setItem(`savefalg`, res.Saved)
                        this.src = res.TargetUrl + `?r=` + Math.random()
                        this.$emit(`update:docbizid`, res.DocBizId)
                    } else {
                        console.error(`load instance failed.${res.Content}`)
                        this.srcdoc = res.Content
                    }
                    this.loading = false
                    // {"Status":"SUCCESS","TargetUrl":"http://localhost:1570/outputs/wth/4562.html","Content":"StartPagenum:0,EndPagenum:0","StartPage":"0","EndPage":"0","DocBizId":"1081"}
                })
                .catch(e => {
                    this.loading = false
                    console.log(e)
                })
        },
        setIframeHeight() {
            let iframe = this.$refs.doc
            if (iframe) {
                var iframeWin = iframe.contentWindow || iframe.contentDocument.parentWindow
                if (iframeWin.document.body) {
                    iframe.height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight || 700
                }
            }
        }
    }
}
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
.display {
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/common/DocFrame.vue